// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__BIAhz","left":"Virtual_left__j5nYX","wrapper":"Virtual_wrapper__dTf1w"};